import { render } from "./EditWallet.vue?vue&type=template&id=6ad639f6&scoped=true"
import script from "./EditWallet.vue?vue&type=script&lang=js"
export * from "./EditWallet.vue?vue&type=script&lang=js"

import "./EditWallet.vue?vue&type=style&index=0&id=6ad639f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad639f6"]])

export default __exports__